module.exports = __webpack_public_path__ + "assets/img/Metrics.0e7eafc8.jpg";